import { render, staticRenderFns } from "./salary.vue?vue&type=template&id=968e1dc8&scoped=true"
import script from "./salary.vue?vue&type=script&lang=js"
export * from "./salary.vue?vue&type=script&lang=js"
import style0 from "./salary.vue?vue&type=style&index=0&id=968e1dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968e1dc8",
  null
  
)

export default component.exports